import { css } from '@emotion/react'
import Image from 'next/image'
export default function CertCard({ title, subtitle, img_path }) {
    return (
        <div className="relative flex justify-center">
            <div className="object-cover border-2 border-gray-silver">
                <Image src={img_path} alt="cert" width="500" height="340" />
            </div>
            <div
                className="bg-white px-3 py-3 absolute -bottom-10 w-full md:w-8/12 shadow-xl"
                css={css`
                    min-width: 300px;
                `}
            >
                <h3 className="font-bold text-black-onyx text-base mb-2">
                    {title}
                </h3>
                <p className="text-xs text-gray-silver">{subtitle}</p>
            </div>
        </div>
    )
}
